import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import s from './PayPalPaymentTerms.scss';
import { URLS } from '@wix/da-url';

export interface Props {
  className?: string;
}

const PayPalPaymentTerms: FC<Props> = ({ className }) => {
  const { t } = useTranslation();

  return (
    <div className={className}>
      <div className={s['terms']}>
        {t('studio.earnings.withdrawToPayPal.confirmation.termsPrefix')}{' '}
        <a href={URLS.TOS} className="text-link-level-2-secondary">
          {t('studio.earnings.withdrawToPayPal.confirmation.termsLink')}
        </a>{' '}
        {t('studio.earnings.withdrawToPayPal.confirmation.termsAnd')}{' '}
        <a
          href="https://www.paypal.com/us/legalhub/paypal/useragreement-full"
          className="text-link-level-2-secondary"
        >
          {t('studio.earnings.withdrawToPayPal.confirmation.userAgreementLink')}
        </a>
        .
      </div>
    </div>
  );
};

PayPalPaymentTerms.displayName = 'PayPalPaymentTerms';

export default PayPalPaymentTerms;
